"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../../Styling");
var Utilities_1 = require("../../../Utilities");
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: 'none'
    };
    var splitButtonDivider = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
    var splitButtonDividerDisabled = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8,
        selectors: (_a = {},
            _a[Styling_1.HighContrastSelector] = {
                backgroundColor: 'GrayText'
            },
            _a)
    };
    var splitButtonStyles = {
        splitButtonContainer: [
            Styling_1.getFocusStyle(theme, { highContrastStyle: buttonHighContrastFocus }),
            {
                display: 'inline-flex',
                selectors: {
                    '.ms-Button--default, .ms-Button--primary': {
                        borderRight: 'none'
                    }
                }
            }
        ],
        splitButtonContainerFocused: {
            outline: 'none!important'
        },
        splitButtonMenuButton: {
            padding: 6,
            height: 'auto',
            boxSizing: 'border-box',
            border: 0,
            borderRadius: 0,
            outline: 'transparent',
            userSelect: 'none',
            display: 'inline-block',
            textDecoration: 'none',
            textAlign: 'center',
            cursor: 'pointer',
            verticalAlign: 'top',
            width: 32,
            marginLeft: -1,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            selectors: (_b = {},
                _b[Styling_1.HighContrastSelector] = {
                    border: "1px solid white",
                    borderLeft: 'none'
                },
                _b)
        },
        splitButtonDivider: splitButtonDivider,
        splitButtonDividerDisabled: splitButtonDividerDisabled,
        splitButtonMenuButtonDisabled: {
            pointerEvents: 'none',
            selectors: (_c = {
                    ':hover': {
                        cursor: 'default'
                    }
                },
                _c[Styling_1.HighContrastSelector] = {
                    border: "1px solid GrayText",
                    color: 'GrayText',
                    backgroundColor: 'Window'
                },
                _c)
        },
        splitButtonFlexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
        },
        splitButtonContainerDisabled: {
            outline: 'none',
            border: 'none'
        }
    };
    return Styling_1.concatStyleSets(splitButtonStyles, customStyles);
    var _a, _b, _c;
});
//# sourceMappingURL=SplitButton.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Button/SplitButton/SplitButton.styles.js
// module id = 726
// module chunks = 0